import { render, staticRenderFns } from "./logisticsInfo.vue?vue&type=template&id=7fad833f&scoped=true"
import script from "./logisticsInfo.vue?vue&type=script&lang=js"
export * from "./logisticsInfo.vue?vue&type=script&lang=js"
import style0 from "./logisticsInfo.vue?vue&type=style&index=0&id=7fad833f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fad833f",
  null
  
)

export default component.exports